import React, { useEffect, useState, useMemo } from 'react';
import { useItems } from '../contexts/ItemsContext';
import { useUser } from '../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import './Programs.css';
import ProductCard from '../components/ProductCard';
import PageHeader from '../components/PageHeader';

const GENRE = 'מיתוג';
const FILTER_TAGS = [
  // כאן תוכל לשנות את הפילטרים כרצונך
  'חנוכה', 'ט\"ו בשבט', 'פורים', 'מכובד', 'צעיר', 'יומולדת', 'חתונת הכסף', 'בת מצווה'
];

const Branding = () => {
  const { itemsByGenre, loadItems, loadingByGenre, errorByGenre } = useItems();
  const { user, addFavorite, removeFavorite } = useUser();
  const navigate = useNavigate();

  const [selectedTags, setSelectedTags] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null); // 'with' | 'without' | null
  const [priceRange, setPriceRange] = useState([10, 200]);

  const items = itemsByGenre[GENRE] || [];

  const maxPrice = useMemo(() => items.length ? Math.ceil(Math.max(...items.map(i => i.price))) : 200, [items]);

  useEffect(() => {
    loadItems(GENRE);
  }, []);

  useEffect(() => {
    if (items.length) setPriceRange([10, Math.ceil(Math.max(...items.map(i => i.price)))]);
  }, [items.length]);
  const loading = loadingByGenre[GENRE];
  const error = errorByGenre[GENRE];

  const highlightStyle = useMemo(() => {
    const containerWidth = 260;
    const marginLeft = 9;
    const marginRight = 9;
    const availableWidth = containerWidth - marginLeft - marginRight;
    const rangeMin = 10;
    const rangeMax = maxPrice;
    const rangeSize = rangeMax - rangeMin;
    const minRatio = (priceRange[0] - rangeMin) / rangeSize;
    const maxRatio = (priceRange[1] - rangeMin) / rangeSize;
    const minPositionReversed = marginLeft + ((1 - minRatio) * availableWidth);
    const maxPositionReversed = marginLeft + ((1 - maxRatio) * availableWidth);
    const leftPx = maxPositionReversed;
    const widthPx = minPositionReversed - maxPositionReversed;
    return {
      left: `${leftPx}px`,
      width: `${widthPx}px`,
    };
  }, [priceRange]);

  const openItem = (item) => {
    navigate(`/item/${item.id}`);
  };

  const isItemFavorite = (item) => {
    if (!user?.likes) return false;
    return user.likes.some(like => like.id === item.id);
  };

  const toggleFavorite = async (item) => {
    if (!user) return;
    if (isItemFavorite(item)) {
      await removeFavorite(item.id);
    } else {
      await addFavorite(item);
    }
  };

  const filteredItems = useMemo(() => {
    return items.filter(it => {
      if (selectedTags.length > 0) {
        const itTypes = (it.types || []).map(t => (typeof t === 'object' ? t.name || t.id : String(t)));
        const itTimings = (it.timings || []).map(t => (typeof t === 'object' ? t.name || t.id : String(t)));
        const all = [...itTypes, ...itTimings];
        const hasAny = selectedTags.some(tag => all.includes(tag));
        if (!hasAny) return false;
      }
      if (selectedVideo === 'with' && !it.video) return false;
      if (selectedVideo === 'without' && it.video) return false;
      if (it.price < priceRange[0] || it.price > priceRange[1]) return false;
      return true;
    });
  }, [items, selectedTags, selectedVideo, priceRange]);

  return (<>
                            <PageHeader>
אזהרת כניסה: מיועד לכאלה שאוהבות לפרגן.{'\n'}
למה לפרגן?{'\n'}
כי מיתוג - זה לא חובה. מיתוג זה מעל הבייסיק.{'\n'}
זה הופך מפגש יום הולדת סתמי - לחגיגה שצרובה בזיכרון של כולם. מסיבת בת מצווה - לאירוע יחודי.{'\n'}
אם את אוהבת להשקיע מעבר, זה המקום בשבילך 🙂!{'\n'}
כאן את בוחרת את המיתוג לאירוע שלך 👇
      </PageHeader>
    <div className="programs-container">
      <div className="programs-frame">
        <div className="programs-filters">
          <div className="filters-row filters-row-top">
            <div className="filters-price">
              <div className="range-wrap">
                <div className="range-track"></div>
                <div className="range-highlight" style={highlightStyle} />
                <input
                  type="range"
                  min={10}
                  max={maxPrice}
                  step={1}
                  value={priceRange[0]}
                  onChange={e => {
                    const newVal = parseInt(e.target.value, 10);
                    if (newVal < priceRange[1]) {
                      setPriceRange([newVal, priceRange[1]]);
                    }
                  }}
                  className="range range-min"
                />
                <input
                  type="range"
                  min={10}
                  max={maxPrice}
                  step={1}
                  value={priceRange[1]}
                  onChange={e => {
                    const newVal = parseInt(e.target.value, 10);
                    if (newVal > priceRange[0]) {
                      setPriceRange([priceRange[0], newVal]);
                    }
                  }}
                  className="range range-max"
                />
              </div>
              <div className="range-values">
                <span>{priceRange[0]} ₪</span>
                <span>{priceRange[1]} ₪</span>
              </div>
            </div>
            <div className="filters-tags">
              {FILTER_TAGS.map(tag => (
                <button
                  key={tag}
                  className={`tag-btn ${selectedTags.includes(tag) ? 'active' : ''}`}
                  onClick={() =>
                    setSelectedTags(
                      selectedTags.includes(tag)
                        ? selectedTags.filter(t => t !== tag)
                        : [...selectedTags, tag]
                    )
                  }
                >
                  {tag}
                </button>
              ))}
              
            </div>
          </div>
          <div className="filters-row filters-row-bottom">
            <button
              className="filters-clear"
              onClick={() => {
                setSelectedTags([]);
                setSelectedVideo(null);
                setPriceRange([10, maxPrice]);
              }}
            >
              נקה מסננים
            </button>
            <div className="filters-count">
              מציג {filteredItems.length} מתוך {items.length}
            </div>
          </div>
        </div>
        {loading && <div className="programs-loading">...חכי שניה, זה עולה</div>}
        {error && <div className="programs-error"> אופסססס, פשלה! איזה בושות! </div>}
        <div className="programs-grid">
          {filteredItems.map(it => (
            <ProductCard
              key={it.id}
              item={it}
              onOpen={openItem}
              onToggleFavorite={toggleFavorite}
              isFavorite={isItemFavorite(it)}
            />
          ))}
        </div>
        {!loading && !error && items.length === 0 && <div className="programs-empty">אין כלום... חבל</div>}
      </div>
    </div>
</>  );
};

export default Branding;
